import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../login/AuthContext";
import "../../styles/pwa-customers.css";

const Sidebar = () => {
    const my_id = sessionStorage.getItem("my_id");
    const location = useLocation();
    const myLogo = sessionStorage.getItem("image");
    const [isMobile, setIsMobile] = useState(false);
    const [activeTab, setActiveTab] = useState('main');
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    
    const defaultMenus = {
        isOpen: false,
        sales: false,
        products: false,
        category: false,
        purchases: false,
        settings: false,
        payments: false,
        locations: false,
        users: false
    }
    const [subMenuOpen, setSubMenuOpen] = useState(defaultMenus);

    // Check if device is mobile
    useEffect(() => {
        const checkMobile = () => {
            // More accurate mobile detection - check both viewport and user agent
            const isMobileViewport = window.innerWidth <= 768;
            const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            // Only show mobile view if both conditions are true AND it's not a desktop browser
            const isDesktopBrowser = !isMobileUserAgent && window.innerWidth > 1024;
            const isMobile = isMobileViewport && isMobileUserAgent && !isDesktopBrowser;
            setIsMobile(isMobile);
            console.log('Sidebar - Mobile detection:', isMobile, 'Viewport:', isMobileViewport, 'UserAgent:', isMobileUserAgent, 'DesktopBrowser:', isDesktopBrowser, 'Width:', window.innerWidth);
        };
        
        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const hideShowMenu = (menuName) => {
        let oldMenu = {
            isOpen: false,
            sales: false,
            products: false,
            category: false,
            purchases: false,
            settings: false,
            payments: false,
            locations: false,
            users: false
        }
        oldMenu[menuName] = !subMenuOpen[menuName];
        oldMenu.isOpen = oldMenu[menuName];
        setSubMenuOpen(oldMenu);
        
        // On mobile, switch to the appropriate tab
        if (isMobile && oldMenu[menuName]) {
            setActiveTab(menuName);
        }
    }

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        if (isMobile) {
            setIsSidebarOpen(true);
        }
    }

    const closeSidebar = () => {
        setIsSidebarOpen(false);
        setSubMenuOpen(defaultMenus);
    }

    // Mobile Tab Navigation Component
    const MobileTabNavigation = () => {
        console.log('MobileTabNavigation render - isMobile:', isMobile);
        if (!isMobile) return null;

        const tabs = my_id == 100 ? [
            { id: 'main', label: 'Main', icon: 'iconsminds-dashboard' },
            { id: 'users', label: 'Users', icon: 'simple-icon-people' },
            { id: 'category', label: 'Category', icon: 'iconsminds-posterous' },
            { id: 'products', label: 'Products', icon: 'iconsminds-shop' },
            { id: 'settings', label: 'Settings', icon: 'simple-icon-settings' }
        ] : [
            { id: 'main', label: 'Main', icon: 'iconsminds-dashboard' },
            { id: 'sales', label: 'Sales', icon: 'iconsminds-digital-drawing' },
            { id: 'purchases', label: 'Purchase', icon: 'iconsminds-data-storage' },
            { id: 'payments', label: 'Payments', icon: 'iconsminds-money-bag' },
            { id: 'settings', label: 'Settings', icon: 'simple-icon-settings' }
        ];

        return (
            <div className="mobile-tab-navigation pwa-tabbar" style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                backgroundColor: '#fff',
                borderTop: '1px solid #e0e0e0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '12px 16px',
                zIndex: 1000,
                boxShadow: '0 -4px 20px rgba(0,0,0,0.1)',
                backdropFilter: 'blur(10px)',
                minHeight: '70px'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    maxWidth: '420px',
                    gap: '4px'
                }}>
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => handleTabClick(tab.id)}
                            className={`pwa-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '8px 4px',
                                border: 'none',
                                backgroundColor: activeTab === tab.id ? 'rgba(30, 58, 138, 0.1)' : 'transparent',
                                color: activeTab === tab.id ? '#1e3a8a' : '#666',
                                fontSize: '10px',
                                fontWeight: activeTab === tab.id ? '600' : '500',
                                cursor: 'pointer',
                                borderRadius: '12px',
                                width: '100%',
                                minHeight: '50px',
                                transition: 'all 0.3s ease',
                                flex: '1 1 0',
                                textAlign: 'center'
                            }}
                        >
                            <i className={tab.icon} style={{ 
                                fontSize: '20px', 
                                marginBottom: '3px',
                                transition: 'all 0.3s ease',
                                display: 'block',
                                textAlign: 'center',
                                width: '100%',
                                lineHeight: '1'
                            }}></i>
                            <span style={{
                                fontSize: '10px',
                                lineHeight: '1.1',
                                textAlign: 'center',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                width: '100%',
                                display: 'block',
                                margin: '0 auto'
                            }}>{tab.label}</span>
                        </button>
                    ))}
                </div>
            </div>
        );
    };

    // Mobile Sidebar Overlay
    const MobileSidebarOverlay = () => {
        if (!isMobile || !isSidebarOpen) return null;

        return (
            <div 
                className="mobile-sidebar-overlay"
                onClick={closeSidebar}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    zIndex: 999,
                    display: 'flex',
                    justifyContent: 'flex-end'
                }}
            >
                <div 
                    className="mobile-sidebar-content"
                    onClick={(e) => e.stopPropagation()}
                    style={{
                        width: '280px',
                        height: '100%',
                        backgroundColor: '#fff',
                        padding: '20px',
                        overflowY: 'auto',
                        transform: isSidebarOpen ? 'translateX(0)' : 'translateX(100%)',
                        transition: 'transform 0.3s ease'
                    }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <h3 style={{ margin: 0, color: '#1e3a8a' }}>
                            {activeTab === 'main' ? 'Main Menu' : 
                             activeTab === 'users' ? 'Users' :
                             activeTab === 'category' ? 'Category' :
                             activeTab === 'products' ? 'Products' :
                             activeTab === 'sales' ? 'Sales' :
                             activeTab === 'purchases' ? 'Purchase' :
                             activeTab === 'payments' ? 'Payments' :
                             activeTab === 'settings' ? 'Settings' : 'Menu'}
                        </h3>
                        <button 
                            onClick={closeSidebar}
                            style={{
                                border: 'none',
                                backgroundColor: 'transparent',
                                fontSize: '24px',
                                cursor: 'pointer',
                                color: '#666'
                            }}
                        >
                            ×
                        </button>
                    </div>
                    {renderMobileMenuContent()}
                </div>
            </div>
        );
    };

    // Render mobile menu content based on active tab
    const renderMobileMenuContent = () => {
        switch (activeTab) {
            case 'main':
                return renderMainMenu();
            case 'users':
                return renderUsersMenu();
            case 'category':
                return renderCategoryMenu();
            case 'products':
                return renderProductsMenu();
            case 'sales':
                return renderSalesMenu();
            case 'purchases':
                return renderPurchasesMenu();
            case 'payments':
                return renderPaymentsMenu();
            case 'settings':
                return renderSettingsMenu();
            default:
                return renderMainMenu();
        }
    };

    // Render main menu items
    const renderMainMenu = () => {
        if (my_id == 100) {
            return (
                <ul style={{ listStyle: 'none', padding: 0 }}>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/size" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/size") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="iconsminds-puzzle" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Size</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/series" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/series") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="iconsminds-palette" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Series</span>
                        </Link>
                    </li>
                </ul>
            );
        } else {
            return (
                <ul style={{ listStyle: 'none', padding: 0 }}>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/customers" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/customers") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-people" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Customers</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/dashboard" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/dashboard") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="iconsminds-dashboard" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Dashboard</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/my-products" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/my-products") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="iconsminds-shop" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>My Products</span>
                        </Link>
                    </li>
                </ul>
            );
        }
    };

    // Render Users menu
    const renderUsersMenu = () => {
        return (
            <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/users" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/users") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="simple-icon-people" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>All Users</span>
                    </Link>
                </li>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/users/pending" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/users/pending") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-clock" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Pending Users</span>
                    </Link>
                </li>
            </ul>
        );
    };

    // Render Category menu
    const renderCategoryMenu = () => {
        return (
            <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/category" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/category") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-posterous" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Category</span>
                    </Link>
                </li>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/category/add" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/category/add") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-add" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Add Category</span>
                    </Link>
                </li>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/subcategory" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/subcategory") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-folder" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Sub Category</span>
                    </Link>
                </li>
            </ul>
        );
    };

    // Render Products menu
    const renderProductsMenu = () => {
        return (
            <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/product" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/product") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-shop" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Products</span>
                    </Link>
                </li>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/product/add" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/product/add") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-add" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Add Product</span>
                    </Link>
                </li>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/stock" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/stock") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-download" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Stock</span>
                    </Link>
                </li>
            </ul>
        );
    };

    // Render Sales menu
    const renderSalesMenu = () => {
        return (
            <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/sales/party" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/sales/party") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="simple-icon-people" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Party</span>
                    </Link>
                </li>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/sales/invoices" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/sales/invoices") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-file" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Sales Invoices</span>
                    </Link>
                </li>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/sales/cash-sales" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/sales/cash-sales") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-money-bag" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Cash Sales</span>
                    </Link>
                </li>
                {/* <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/sales/pending-orders" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/sales/pending-orders") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-clock" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Sales Pending Orders</span>
                    </Link>
                </li> */}
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/sales-return" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/sales-return") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-arrow-left" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Sales Return</span>
                    </Link>
                </li>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/sales/proforma" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/sales/proforma") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-file" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Proforma</span>
                    </Link>
                </li>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/sales/sample-brackage" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/sales/sample-brackage") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-gift-box" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Sample & Brackage</span>
                    </Link>
                </li>
            </ul>
        );
    };

    // Render Purchases menu
    const renderPurchasesMenu = () => {
        return (
            <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/purchase" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/purchase") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-data-storage" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Purchases</span>
                    </Link>
                </li>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/purchase/add" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/purchase/add") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-add" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Add Purchase</span>
                    </Link>
                </li>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/purchase-return" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/purchase-return") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-arrow-right" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Purchase Return</span>
                    </Link>
                </li>
            </ul>
        );
    };

    // Render Payments menu
    const renderPaymentsMenu = () => {
        return (
            <ul style={{ listStyle: 'none', padding: 0 }}>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/payments/ledger" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/payments/ledger") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-file" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Ledger</span>
                    </Link>
                </li>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/payments" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/payments") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-money-bag" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Payment</span>
                    </Link>
                </li>
                <li style={{ marginBottom: '12px' }}>
                    <Link 
                        onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                        to="/payments/out-standing" 
                        style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            padding: '12px', 
                            textDecoration: 'none', 
                            color: '#333',
                            backgroundColor: location.pathname.includes("/payments/out-standing") ? '#f0f8ff' : 'transparent',
                            borderRadius: '8px'
                        }}
                    >
                        <i className="iconsminds-wallet" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                        <span>Outstanding</span>
                    </Link>
                </li>
            </ul>
        );
    };

    // Render Settings menu
    const renderSettingsMenu = () => {
        if (my_id == 100) {
            return (
                <ul style={{ listStyle: 'none', padding: 0 }}>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/app-settings" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/app-settings") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-settings" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>App Settings</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/city" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/city") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-map" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>City</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/order-permission" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/order-permission") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-shield" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Order Permission</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/catalogue" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/catalogue") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-book-open" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Catalogue</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/transport" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/transport") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="iconsminds-car" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Transport</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/terms" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/terms") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="iconsminds-file" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Terms</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/contact-persons" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/contact-persons") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-people" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Contact Persons</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/vehicles" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/vehicles") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="iconsminds-car" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Vehicles</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/workers" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/workers") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-people" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Workers</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/banks" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/banks") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-credit-card" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Banks</span>
                        </Link>
                    </li>
                </ul>
            );
        } else {
            return (
                <ul style={{ listStyle: 'none', padding: 0 }}>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/profile" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/profile") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-user" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Profile</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/change-password" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/change-password") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="iconsminds-lock-2" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Change Password</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/order-permission" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/order-permission") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-shield" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Order Permission</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/catalogue" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/catalogue") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-book-open" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Catalogue</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/transport" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/transport") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="iconsminds-car" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Transport</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/terms" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/terms") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="iconsminds-file" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Terms</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/contact-persons" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/contact-persons") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-people" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Contact Persons</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/vehicles" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/vehicles") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="iconsminds-car" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Vehicles</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/workers" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/workers") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-people" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Workers</span>
                        </Link>
                    </li>
                    <li style={{ marginBottom: '12px' }}>
                        <Link 
                            onClick={() => { setSubMenuOpen(defaultMenus); closeSidebar(); }} 
                            to="/settings/banks" 
                            style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                padding: '12px', 
                                textDecoration: 'none', 
                                color: '#333',
                                backgroundColor: location.pathname.includes("/settings/banks") ? '#f0f8ff' : 'transparent',
                                borderRadius: '8px'
                            }}
                        >
                            <i className="simple-icon-credit-card" style={{ marginRight: '12px', fontSize: '18px' }}></i>
                            <span>Banks</span>
                        </Link>
                    </li>
                </ul>
            );
        }
    };

    return (
        <>
            {/* Desktop Sidebar */}
            {!isMobile && (
                <div className="menu">
                    <div className="main-menu">
                        <div className="scroll">
                            {my_id && <ul className="list-unstyled">
                                {my_id == 100 ? <>
                                    <li className={location.pathname.includes("/users") ? "active" : ""}>
                                        <Link onClick={() => hideShowMenu('users')} to="#" style={{ height: 90 }}>
                                            <i className="simple-icon-people"></i> Users
                                        </Link>
                                    </li>
                                    <li className={location.pathname.includes("/category") ? "active" : ""}>
                                        <Link onClick={() => hideShowMenu('category')} to="#" style={{ height: 90 }}>
                                            <i className="iconsminds-posterous"></i> Category
                                        </Link>
                                    </li>
                                    <li className={location.pathname.includes("/size") ? "active" : ""}>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/size" style={{ height: 90 }}>
                                            <i className="iconsminds-puzzle"></i><span>Size</span>
                                        </Link>
                                    </li>
                                    <li className={location.pathname.includes("/series") ? "active" : ""}>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/series" style={{ height: 90 }}>
                                            <i className="iconsminds-palette"></i><span>Series</span>
                                        </Link>
                                    </li>
                                    <li className={location.pathname.includes("/products") ? "active" : ""}>
                                        <Link onClick={() => hideShowMenu('products')} to="#" style={{ height: 90 }}>
                                            <i className="iconsminds-shop"></i> Products
                                        </Link>
                                    </li>
                                    <li className={location.pathname.includes("/settings") ? "active" : ""}>
                                        <Link onClick={() => hideShowMenu('settings')} to="#" style={{ height: 90 }}>
                                            <i className="simple-icon-settings"></i> Settings
                                        </Link>
                                    </li>
                                </> : <>
                                    <li className={location.pathname.includes("/customers") ? "active" : ""}>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/customers" style={{ height: 70 }}>
                                            <i className="simple-icon-people"></i><span>Customers</span>
                                        </Link>
                                    </li>
                                    <li className={location.pathname.includes("/dashboard") ? "active" : ""}>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/dashboard" style={{ height: 90 }}>
                                            <i className="iconsminds-dashboard"></i><span>Dashboard</span>
                                        </Link>
                                    </li>
                                    <li className={location.pathname.includes("/my-products") ? "active" : ""}>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/my-products" style={{ height: 90 }}>
                                            <i className="iconsminds-shop"></i><span>My Products</span>
                                        </Link>
                                    </li>
                                    <li className={location.pathname.includes("/sales") ? "active" : ""}>
                                        <Link onClick={() => hideShowMenu('sales')} to="#" style={{ height: 90 }}>
                                            <i className="iconsminds-digital-drawing"></i> Sales
                                        </Link>
                                    </li>
                                    <li className={location.pathname.includes("/purchase") ? "active" : ""}>
                                        <Link onClick={() => hideShowMenu('purchases')} to="#" style={{ height: 90 }}>
                                            <i className="iconsminds-data-storage"></i> Purchase
                                        </Link>
                                    </li>
                                    <li className={location.pathname.includes("/settings") ? "active" : ""}>
                                        <Link onClick={() => hideShowMenu('settings')} to="#" style={{ height: 90 }}>
                                            <i className="simple-icon-settings"></i> Settings
                                        </Link>
                                    </li>
                                    <li className={location.pathname.includes("/payments") ? "active" : ""}>
                                        <Link onClick={() => hideShowMenu('payments')} to="#" style={{ height: 90 }}>
                                            <i className="iconsminds-money-bag"></i><span>Payments</span>
                                        </Link>
                                    </li>
                                </>}
                            </ul>}
                        </div>
                    </div>

                    <div className="sub-menu" style={{ transform: subMenuOpen.isOpen ? 'translateX(0px)' : 'translateX(-230px)' }}>
                        <div className="scroll">
                            {subMenuOpen.users && <ul className="list-unstyled d-block">
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/users">
                                        <i className="simple-icon-people" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">All Users</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/users/pending">
                                        <i className="iconsminds-clock" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Pending Users</span>
                                    </Link>
                                </li>
                            </ul>}
                            {subMenuOpen.category && <ul className="list-unstyled d-block">
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/category">
                                        <i className="iconsminds-posterous" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Category</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/category/add">
                                        <i className="iconsminds-add" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Add Category</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/subcategory">
                                        <i className="iconsminds-folder" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Sub Category</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/subcategory/add">
                                        <i className="iconsminds-add" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Add Sub Category</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/vehicles-category">
                                        <i className="iconsminds-car" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Vehicles Category</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/vehicles-category/add">
                                        <i className="iconsminds-add" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Add Vehicles Category</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/worker-category">
                                        <i className="simple-icon-people" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Workers Category</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/worker-category/add">
                                        <i className="iconsminds-add" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Add Workers Category</span>
                                    </Link>
                                </li>
                            </ul>}
                            {subMenuOpen.products && <ul className="list-unstyled d-block">
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/product">
                                        <i className="iconsminds-shop" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Products</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/product/add">
                                        <i className="iconsminds-add" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Add Product</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/product/add-image">
                                        <i className="iconsminds-image" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Add Product Image</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/product/sub-product">
                                        <i className="iconsminds-folder" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Sub Product</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/product/sub-product/add">
                                        <i className="iconsminds-add" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Add Sub Product</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/product/specification">
                                        <i className="iconsminds-list" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Specification</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/stock">
                                        <i className="iconsminds-download" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Stock</span>
                                    </Link>
                                </li>
                            </ul>}
                            {subMenuOpen.purchases && <ul className="list-unstyled d-block">
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/purchase">
                                        <i className="iconsminds-data-storage" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Purchases</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/purchase/add">
                                        <i className="iconsminds-add" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Add Purchase</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/purchase-return">
                                        <i className="iconsminds-arrow-right" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Purchase Return</span>
                                    </Link>
                                </li>
                            </ul>}
                            {subMenuOpen.sales && <ul className="list-unstyled d-block">
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales/party">
                                        <i className="simple-icon-people" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Party</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales/invoices">
                                        <i className="iconsminds-file" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Sales Invoices</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales/pending-orders">
                                        <i className="iconsminds-clock" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Sales Pending Orders</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales-return">
                                        <i className="iconsminds-arrow-left" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Sales Return</span>
                                    </Link>
                                </li>
                                {/* <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales/cash-sales">
                                        <i className="iconsminds-money-bag" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Cash Sales</span>
                                    </Link>
                                </li> */}
                                {/* <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales/proforma">
                                        <i className="iconsminds-file" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Proforma</span>
                                    </Link>
                                </li> */}
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/sales/sample-brackage">
                                        <i className="iconsminds-gift-box" style={{ marginRight: '8px' }}></i>
                                        <span className="d-inline-block">Sample & Brackage</span>
                                    </Link>
                                </li>
                            </ul>}
                            {subMenuOpen.settings && <ul className="list-unstyled d-block">
                                {my_id == 100 ? <>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/send-notification">
                                            <i className="iconsminds-mail" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Send Notification</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/slider">
                                            <i className="iconsminds-image" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Slider</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/city">
                                            <i className="simple-icon-map" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">City</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/state">
                                            <i className="simple-icon-map" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">State</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/faqs">
                                            <i className="iconsminds-question" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Faqs</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/help-line">
                                            <i className="iconsminds-phone" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Help Line</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/app-settings">
                                            <i className="simple-icon-settings" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">App Settings</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/policy-settings">
                                            <i className="simple-icon-shield" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Privacy Policy</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/terms-settings">
                                            <i className="iconsminds-file" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Terms & Conditions</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/refund-settings">
                                            <i className="iconsminds-money-bag" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Refund Policy</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/shipping-settings">
                                            <i className="iconsminds-car" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Shipping Policy</span>
                                        </Link>
                                    </li>
                                </> : <>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/order-permission">
                                            <i className="simple-icon-shield" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Order Permission</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/catalogue">
                                            <i className="simple-icon-book-open" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Catalogue Upload</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/transport">
                                            <i className="iconsminds-car" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Transporter</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/terms">
                                            <i className="iconsminds-file" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Billing Terms</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/contact-persons">
                                            <i className="simple-icon-people" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Contact Persons</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/vehicles">
                                            <i className="iconsminds-car" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Vehicles</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/workers">
                                            <i className="simple-icon-people" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Workers</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/banks">
                                            <i className="simple-icon-credit-card" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Banks</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/profile">
                                            <i className="simple-icon-user" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Profile</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/settings/change-password">
                                            <i className="iconsminds-lock" style={{ marginRight: '8px' }}></i>
                                            <span className="d-inline-block">Change Password</span>
                                        </Link>
                                    </li>
                                </>}
                            </ul>}
                            {subMenuOpen.payments && <ul className="list-unstyled d-block">
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/payments/party-payment-ledger">
                                        <span className="d-inline-block">Party Ledger</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={() => setSubMenuOpen(defaultMenus)} to="/payments/add">
                                        <span className="d-inline-block">Add Payment</span>
                                    </Link>
                                </li>
                            </ul>}
                        </div>
                    </div>
                </div>
            )}

            {/* Mobile Components */}
            <MobileTabNavigation />
            <MobileSidebarOverlay />
        </>
    );
};

export default Sidebar;
